import { Button } from 'primereact/button'
import React, { useEffect, useState } from 'react'
import { Sign } from '../../shared/component/Sign';
import { Menubar } from 'primereact/menubar';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { StatementInvoiceService } from '../xu-ly-sai-sot/StatementInvoiceService';
import moment from 'moment';
import { getLawBases } from '../../utils/statementHelper';

const HDDT = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [doc, setDoc] = useState(null);
  const invoiceListNumber =
    doc?.invoiceListNumber ||
    doc?.relatedInvoiceListNumber ||
    doc?.statementNumber;
  const invoiceListDate =
    doc?.invoiceListDate || doc?.relatedInvoiceListDate || doc?.statementDate;
  const isMultipleInvoiceStatement = invoiceListNumber || invoiceListDate;

  useEffect(() => {
    StatementInvoiceService.getDetail(id, { taxCode: searchParams.get('taxCode') }).then(res => {
      setDoc(res);
    });
  }, []);

  return <>
    <div className="layout-topbar justify-content-between">
      <Link to="/" className="layout-topbar-logo">
        <img src={'assets/layout/images/LogoAppMinvoice_new.png'} alt="logo" />
      </Link>

      <Menubar model={[]}
          className="app-menu"
        />
      </div>
      <div className="layout-main-container">
        <div className="layout-main">
          <div className="w-full flex flex-column align-items-center justify-content-center gap-2 pb-8">
            <div className="flex flex-column align-items-center w-7 bg-white p-6 border-round">
              <b>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</b>
              <b>Độc lập - Tự do - Hạnh phúc</b>
              <br />
              <br />
              <b>
                BIÊN BẢN {doc?.documentType === 2 ? "ĐIỀU CHỈNH" : "THAY THẾ"}{" "}
                HÓA ĐƠN
              </b>
              <br />
              <b>Số biên bản: {doc?.documentNo}</b>
              <br />
              <div className="flex flex-column gap-2">
                {getLawBases(doc?.documentDate).map((base, idx) => (
                  <i key={idx}>- {base}</i>
                ))}
              </div>
              <div className="grid">
                <p className="col-12">
                  Hôm nay,{" "}
                  {doc?.documentDate
                    ? (() => {
                        const d = moment(doc.documentDate);
                        return `ngày ${d.format("DD")} tháng ${d.format("MM")} năm ${d.format("YYYY")}`;
                      })()
                    : ""}{" "}
                  chúng tôi gồm có:
                </p>
                <b className="col-12">
                  BÊN A (BÊN BÁN): {doc?.sellerLegalName}
                </b>
                <p className="col-2">Địa chỉ:</p>
                <p className="col-10">{doc?.sellerAddress}</p>
                <p className="col-2">Mã số thuế:</p>
                <p className="col-4">{doc?.sellerTaxCode}</p>
                <p className="col-1">Đại diện:</p>
                <p className="col-5">{doc?.sellerPersonContact}</p>
                <p className="col-2">Số điện thoại:</p>
                <p className="col-4">{doc?.sellerTel}</p>
                <p className="col-1">Chức vụ:</p>
                <p className="col-5">{doc?.sellerPosition}</p>
                <b className="col-12">BÊN B (BÊN MUA): {doc?.buyerLegalName}</b>
                <p className="col-2">Địa chỉ:</p>
                <p className="col-10">{doc?.buyerAddress}</p>
                <p className="col-2">MST/CCCD chủ hộ:</p>
                <p className="col-4">{doc?.buyerTaxCode}</p>
                <p className="col-1">Đại diện:</p>
                <p className="col-5">{doc?.buyerPersonContact}</p>
                <p className="col-2">Số điện thoại:</p>
                <p className="col-4">{doc?.buyerTel}</p>
                <p className="col-1">Chức vụ:</p>
                <p className="col-5">{doc?.buyerPosition}</p>
                <p className="col-12">
                  {isMultipleInvoiceStatement ? (
                    <i>
                      Hai bên thống nhất lập biên bản này để xác nhận sai sót và lập hóa đơn{" "}
                      {doc?.documentType === 2 ? "Điều chỉnh" : "Thay thế"} cho
                      nhiều hóa đơn sai sót kèm theo bảng kê có Số{" "}
                      {invoiceListNumber || "...."} Ngày{" "}
                      {invoiceListDate
                        ? moment(invoiceListDate).format("DD/MM/YYYY")
                        : "...."}{" "}
                      theo quy định.
                    </i>
                  ) : (
                    <>
                      Hai bên thống nhất lập biên bản này để{" "}
                      {doc?.documentType === 2 ? "điều chỉnh" : "thay thế"} hóa
                      đơn theo quy định.
                    </>
                  )}
                </p>
                {/* <b className="col-3">
                  Hóa đơn bị{" "}
                  {doc?.documentType === 2 ? "điều chỉnh" : "thay thế"}:
                </b>
                <p className="col-9">
                  Mẫu số <b>{doc?.invoiceSerial.substring(0, 1)}</b>, ký hiệu{" "}
                  <b>
                    {doc?.invoiceSerial.substring(1, doc?.invoiceSerial.length)}
                  </b>
                  , số <b>{doc?.invoiceNumber}</b>, ngày{" "}
                  <b>{moment(doc?.invoiceDate).format("DD/MM/YYYY")}</b>
                </p> */}
                <b className="col-3">
                  Lý do {doc?.documentType === 2 ? "điều chỉnh" : "thay thế"}:
                </b>
                <p className="col-9">{doc?.reason}</p>
                <p className="col-12">
                  Chúng tôi cam kết và hoàn toàn chịu trách nhiệm về việc{" "}
                  {doc?.documentType === 2 ? "điều chỉnh" : "thay thế"} cho hóa
                  đơn này.
                </p>
                <div className="col-6 flex flex-column align-items-center">
                  <b>ĐẠI DIỆN BÊN A</b>
                  <i>(Chữ kí số, chữ ký điện tử)</i>
                  <br />
                  {doc?.status === 2 ? (
                    <div className="grid grid-nogutter relative border-2 border-solid border-green-500 text-green-500 px-4 w-9">
                      <span className="col-12">Signature valid</span>
                      <span className="col-3">Kí bởi:</span>
                      <span className="col-9">{doc?.sellerLegalName}</span>
                      <span className="col-3">Ngày ký:</span>
                      <span className="col-9">
                        {moment(doc?.dateSign).format("DD/MM/YYYY HH:mm:ss")}
                      </span>
                      <img
                        className="col-2 absolute"
                        style={{
                          top: "60%",
                          right: "10px",
                          transform: "translateY(-50%)",
                        }}
                        src={"assets/layout/images/check.png"}
                        alt=""
                      />
                    </div>)
                    : <Button className='p-button-secondary' label='Ký điện tử' icon="pi pi-user-edit" onClick={() => {
                      Sign({
                        "CommandName": "StatementInvoice",
                        "taxCode": searchParams.get('taxCode'),
                        "Id": doc?.id,
                        "InvoiceIdArray": [doc?.id]
                      }).then(() => {
                        StatementInvoiceService.getDetail(id, { taxCode: searchParams.get('taxCode') }).then(res => {
                          setDoc(res);
                        });
                      });
                    }} />

                }
              </div>
              <div className='col-6 flex flex-column align-items-center'>
                <b>ĐẠI DIỆN BÊN B</b>
                <i>(Chữ kí số, chữ ký điện tử)</i>
                <br />
                {
                  doc?.buyerStatus === 2 ?
                    <div className='grid grid-nogutter relative border-2 border-solid border-green-500 text-green-500 px-4 w-9'>
                      <span className='col-12'>Signature valid</span>
                      <span className='col-3'>Kí bởi:</span>
                      <span className='col-9'>{doc?.buyerLegalName}</span>
                      <span className='col-3'>Ngày ký:</span>
                      <span className='col-9'>{moment(doc?.buyerDateSign).format('DD/MM/YYYY HH:mm:ss')}</span>
                      <img className='col-2 absolute' style={{ top: '60%', right: '10px', transform: 'translateY(-50%)' }} src={'assets/layout/images/check.png'} alt="" />
                    </div>
                    :
                    <Button className='p-button-secondary' label='Ký điện tử' icon="pi pi-user-edit" onClick={() => {
                      Sign({
                        "CommandName": "StatementInvoiceBuyer",
                        "taxCode": searchParams.get('taxCode'),
                        "Id": doc?.id,
                        "InvoiceIdArray": [doc?.id]
                      }).then(() => {
                        StatementInvoiceService.getDetail(id, { taxCode: searchParams.get('taxCode') }).then(res => {
                          setDoc(res);
                        });
                      });
                    }} />
                }
              </div>
            </div>
          </div>
          <Button label='Tải xuống' onClick={async () => {
            try {
              const res = await StatementInvoiceService.getPdfUrlV2(doc?.id, { taxCode: searchParams.get('taxCode') });
              const pdfUrl = res;
              const response = await fetch(pdfUrl, { method: 'GET' });
              const blob = await response.blob();
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `${doc?.id}.pdf`;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
            } catch (error) {
              alert('Tải xuống thất bại!');
            }
          }} />
          {/* {renderSign()} */}
        </div >
         <div className='grid no-gutter border-dashed border-bottom-none border-left-none border-right-none border-top-1'>
          <div className='col-4'>
            <p className='font-bold underline'>CÔNG TY CP CÔNG NGHỆ TRƯỜNG MINH THỊNH</p>
            <p>Mã số thuế:	0311174986</p>
            <p>Địa chỉ: 22 Đường số 8, Khu 2 – Bùi Minh Trực, Phường 5, Quận 8, Thành phố Hồ Chí Minh, Việt Nam</p>
            <p>SĐT: 0908075455</p>
            <Link to='mailto:info@minvoice.vn'>Email: info@wiinvoice</Link>
          </div>
           <div className='col-4'>
            <p className='font-bold underline'>VĂN PHÒNG ĐẠI DIỆN MIỀN TRUNG</p>
            <p>Địa chỉ: 110B Nguyễn Hữu Thọ, phường Hòa Cường, TP Đà Nẵng</p>
          </div>
         <div className='col-4'>
            <p className='font-bold underline'>VĂN PHÒNG ĐẠI DIỆN MIỀN BẮC</p>
            <p>Địa chỉ: 44C ngõ 63 Lê Đức Thọ, Phường Từ Liêm, TP Hà Nội</p>
          </div>
          {/* <div className='col-4'>
            <p className='font-bold underline'>CHI NHÁNH HÀ NỘI</p>
            <p>Địa chỉ: Số nhà 27 liền kề 14 KĐT Văn Khê, Quận Hà Đông, Hà Nội</p>
            <p>SĐT: 0899 90 16 18</p>
            <Link to='mailto:info@minvoice.vn'>Email: info@minvoice.vn</Link>
          </div>
          <div className='col-4'>
            <p className='font-bold underline'>CHI NHÁNH ĐÀ NẴNG</p>
            <p>Địa chỉ: Số 100, Lê Tấn Trung, P. Thọ Quang,Quận Sơn Trà</p>
            <p>SĐT: 0915 777 591</p>
            <Link to='mailto:info@minvoice.vn'>Email: info@minvoice.vn</Link>
          </div>
          <div className='col-4'>
            <p className='font-bold underline'>CHI NHÁNH HẢI DƯƠNG</p>
            <p>Địa chỉ: Khu 1, Phường Thạch Khôi, Tp.Hải Dương</p>
            <p>SĐT: 02203 833 666</p>
            <Link to='mailto:info@minvoice.vn'>Email: info@minvoice.vn</Link>
          </div>
          <div className='col-4'>
            <p className='font-bold underline'>CHI NHÁNH THANH HÓA</p>
            <p>Địa chỉ: Số 68 Trần Bình Trọng, P.Đông Sơn,Thành phố Thanh Hóa</p>
            <p>SĐT: 0901 80 16 18</p>
            <Link to='mailto:info@minvoice.vn'>Email: info@minvoice.vn</Link>
          </div>
          <div className='col-4'>
            <p className='font-bold underline'>CHI NHÁNH ĐỒNG NAI</p>
            <p>Địa chỉ: R318, Đường D8, KP 7, P. Thống Nhất,Thành phố Biên Hoà</p>
            <p>SĐT: 0919 29 22 33</p>
            <Link to='mailto:info@minvoice.vn'>Email: info@minvoice.vn</Link>
          </div>
          <div className='col-4'>
            <p className='font-bold underline'>CHI NHÁNH MIỀN TRUNG</p>
            <p>Địa chỉ: 230/8 Nguyễn Công Trứ, P.An Hải Đông, Q.Sơn Trà, TP.Đà Nẵng</p>
            <p>SĐT: 0982.839.777 - 0905.332.011</p>
            <Link to='mailto:mientrung@minvoice.vn'>Email: mientrung@minvoice.vn</Link>
          </div> */}
          <div className='col-12 flex align-items-center justify-content-between pt-4 pb-8 border-dashed border-bottom-none border-left-none border-right-none border-top-1'>
            <p className='m-0'>Copyrights © 2025 Giải pháp hóa đơn điện tử  <span className='font-bold'>WiInvoice</span>. All Rights Reserved.</p>
            {/* <div className='flex align-items-center gap-4'>
              <Button className='p-button-outlined p-button-secondary' label='Youtube' icon="pi pi-youtube" onClick={() => window.open('https://www.youtube.com/channel/UCJd2b57TomvwJOMyXhYVQpQ', '_blank')} />
              <Button className='p-button-outlined p-button-secondary' label='Facebook' icon="pi pi-facebook" onClick={() => window.open('https://www.facebook.com/hoadondientu.m.invoice', '_blank')} />
              <Button className='p-button-outlined p-button-secondary' label='0901 80 16 18' icon="pi pi-phone" onClick={() => window.open('tel:0901801618', '_blank')} />
              <Button className='p-button-outlined p-button-secondary' label='Demo' icon="pi pi-youtube" onClick={() => window.open('https://www.youtube.com/watch?v=umLV8QLS9A4&feature=youtu.be', '_blank')} />
            </div> */}
          </div>
        </div>
      </div>
    </div >

  </>
}

export default HDDT